import {
  Box,
  Button,
  Checkbox,
  Dialog,
  FormControlLabel,
  FormGroup,
  IconButton,
  Radio,
  Rating,
  Slider,
  Typography,
} from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { resetFilters, setFilterState } from '../../features/filter/filterSlice';
import StarIcon from '@mui/icons-material/Star';
import CloseIcon from '@mui/icons-material/Close';
import { colors } from '../../styles/colors';
import { roundPrice, roundPriceTransfers } from '../../helpers/RoundPrice';
import { setDialogState } from '../../features/dialog/dialogSlice';
import { useAppSelector } from '../../hooks/useAppReducer';
import { useDispatch } from 'react-redux';
import { setFindButtonClick } from '../../features/findButtonClicked/findButtonClicked';
import { isEmpty } from '../../helpers/isEmpty';
import { exchangeRateCalculation } from '../../features/exchangeRateCalculation/exchangeRateCalculation';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { setSessionStorage } from '../../helpers/storage';
import { sortRoom } from '../../helpers/sortRoom';
import { isDiscountValidDate } from '../../helpers/isDiscountValidDate';
import { calculatePerPersonPrice } from '../../helpers/calculatePerPersonPrice';
import { formatPrice } from '../../helpers/formatPrice'
import { ReactComponent as HolidayTypeSearchIcon } from "../../assets/icons/HolidayTypeSearchIcon.svg";
import { ReactComponent as RegionSearchIcon } from "../../assets/icons/RegionSearchIcon.svg";
import { ReactComponent as RatingStarSearchIcon } from "../../assets/icons/RatingStarSearchIcon.svg"
import { ReactComponent as MaxPriceSearchIcon } from "../../assets/icons/MaxPriceSearchIcon.svg";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { ImportExportOutlined } from '@mui/icons-material';
// const holidayType = [
//   'Adults Only',
//   'Honeymoons',
//   'Family Holidays',
//   'Twin & Multi Centre Holidays',
//   'Tours',
//   'Cruise Holidays',
//   'Weddings',
//   'Luxury Holidays',
//   'All Inclusive',
//   'Villa Holidays',
// ];

interface filterSearchDialogProps {
  // setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const FilterSearchDialog = (props: filterSearchDialogProps) => {
  //! States
  const { filters } = useAppSelector((state) => state.filters);
  const dialogState = useAppSelector((state) => state.dialog.dialogState);
  const { stepper } = useAppSelector((state) => state.stepper);
  const { holidayPackage, holidayTypes, filterCounts, regionCounts, regionTypes, filteredHolidayPackage } = useAppSelector(
    (state) => state.holidayPackage
  );
  const [showAll, setShowAll] = useState<any>({
    region: false,
    hotels: false,
  });
  const { hotelDetails } = useAppSelector((state) => state.hotelDetails);
  const { flightRoom } = useAppSelector((state) => state.flightRoom);
  const { holiday } = useAppSelector((state) => state.holidaySummary);
  // For Expand
  const [openHoliday, setOpenHoliday] = useState(true);
  const [openRegion, setOpenRegion] = useState(true);
  const [openRating, setOpenRating] = useState(true);
  const [openPrice, setOpenPrice] = useState(true);
  const [openSort, setOpenSort] = useState(true);

  //! Hooks
  const [pricePerPerson, setPricePerPerson] = useState<any>(filters.price);
  const [resultAvailableHotelRatings, setResultAvailableHotelRatings] = useState([]);
  const totalGuests = Number(flightRoom.searchCriteria.adults + flightRoom.searchCriteria.childrens);
  const isPlataniumHotel = hotelDetails?.HotelInfo?.HotelInfo?.platinumHotel
    ? Number(hotelDetails.HotelInfo.HotelInfo.platinumHotel) !== 0
    : false;
  const signForPricing = process.env.REACT_APP_CURRENCY_SYMBOL;
  //! Variables
  const dispatch = useDispatch();

  useEffect(() => {
    let ratings: any = [];
    holidayPackage?.Packages?.results
      ?.map((item: any) => item.HotelInfo)
      .filter((item: any) => {
        if (item?.hotel_rating) {
          let value = 0;
          if (item.hotel_classification === '0') {
            value = Number(item.hotel_rating);
          } else {
            if (item.hotel_rating === '-1') {
              value = Number(item.hotel_rating);
            } else {
              value =
                item?.hotel_classification === '2'
                  ? Number(item.hotel_rating) === 5
                    ? 5
                    : Number(item.hotel_rating) + 0.5
                  : Number(item.hotel_rating);
            }
          }

          if (!ratings.includes(value)) {
            ratings.push(value);
          }
        }
        return item;
      });
    setResultAvailableHotelRatings(ratings.sort((a: number, b: number) => b - a));
  }, [holidayPackage?.Packages?.results]);

  const minPackage = useMemo(() => {
    return holidayPackage?.Packages?.results?.map((data: any, index: number) => {
      const isEqual = data?.SearchResult?.hotel_id === flightRoom?.hotel_id;

      const getRooms =
        stepper === 0
          ? sortRoom(data?.SearchResult, filters)
          : isEqual
            ? flightRoom?.multiRooms
            : sortRoom(data?.SearchResult, filters);

      const getTransfer: any =
        stepper === 0
          ? isEmpty(data?.SearchResult?.transfer?.pagedata?.[0].Transfer)
          : isEqual
            ? isEmpty(holiday?.transfer)
            : isEmpty(data?.transfer?.pagedata?.[0]?.Transfer);
      const totalTransfer = getTransfer.cust_tot_sell_amt ? parseFloat(getTransfer.cust_tot_sell_amt) : 0;
      // const totalTransfer = getTransfer.cust_tot_sell_amt ? (parseFloat(getTransfer.cust_tot_sell_amt) * parseFloat(getTransfer.exchange_rate)) : 0;
      const transferPrice = roundPriceTransfers(
        totalTransfer,
        flightRoom.searchCriteria.isAdditionalTransferAmountAdd,
        totalGuests,
        flightRoom,
        data.SearchResult.transfer?.pagedata[0]?.Transfer?.exchange_rate || 0
      );

      const transfer_add = !flightRoom?.searchCriteria?.destination?.default_transfer ? transferPrice : 0

      let price: any = 0;
      if (getRooms.length > 0) {
        getRooms.map((f: any) => {
          price = price + Number(f.total_package);
        });
      }

      const totalPrice = (price) / totalGuests;
      let finalPrice;
      if (flightRoom?.searchCriteria?.destination?.discountPrice?.isDiscountUK
        && process.env.REACT_APP_PROJECT_COUNTRY === "uk"
        && isDiscountValidDate()) {
        finalPrice = Number(formatPrice(String(calculatePerPersonPrice(roundPrice(totalPrice), totalGuests))));
      } else if (flightRoom?.searchCriteria?.destination?.discountPrice?.isDiscountIE
        && process.env.REACT_APP_PROJECT_COUNTRY === "ie"
        && isDiscountValidDate()) {

        finalPrice = Number(formatPrice(String(calculatePerPersonPrice(roundPrice(totalPrice), totalGuests))));
      } else {
        finalPrice = Number(roundPrice(String(totalPrice)));
      }
      return finalPrice;
      //   return Number(roundPrice(String(totalPrice)));
    });
  }, [holidayPackage?.Packages?.results, stepper, flightRoom.multiRooms]);

  const price = {
    low:
      minPackage?.length !== 0
        ? minPackage?.reduce((min: number, current: number) => {
          return min > current ? current : min;
        })
        : 0,
    high:
      minPackage?.length !== 0
        ? minPackage?.reduce((max: number, current: number) => {
          return max > current ? max : current;
        })
        : 0,
  };

  //! Functions
  const handleClear = () => {
    dispatch(resetFilters());
    setPricePerPerson([price?.low, price?.high]);
    dispatch(
      setFilterState({
        holidayType: [],
        starRating: [],
        hotelName: '',
        sorting: 'Popularity',
        regionType: [],
        price: [price?.low, price?.high],
      })
    );
  };

  const handleChangeHolidayTypeFilter = (e: any) => {
    let holidayTypes: any = [...filters.holidayType];

    if (e.target.checked) {
      holidayTypes.push(e.target.value);
    } else {
      holidayTypes = holidayTypes.filter((item: any) => item !== e.target.value);
    }

    dispatch(setFilterState({ ...filters, holidayType: holidayTypes }));
  };

  const handleChangeRating = (e: any) => {
    let ratings = [...filters.starRating];

    if (e.target.checked) {
      ratings.push(Number(e.target.value));
    } else {
      ratings = ratings.filter((item: any) => item !== Number(e.target.value));
    }

    dispatch(setFilterState({ ...filters, starRating: ratings }));
  };

  const handleChangeShowAllFilters = (name: any) => {
    setShowAll({
      ...showAll,
      [name]: !showAll[name],
    });
  };

  const handleChangeRegionTypeFilter = (e: any) => {
    const regionTypes: any = [...filters.regionType];
    if (e.target.checked) {
      regionTypes.push(e.target.value);
    } else {
      regionTypes.splice(regionTypes.indexOf(e.target.value), 1);
    }
    dispatch(setFilterState({ ...filters, regionType: regionTypes }));
  };

  const handleReset = () => {
    // dispatch(setIsClickedFilters(true))
    dispatch(resetFilters());
    // setHotelNameSearchText('');
    dispatch(setFilterState({
      holidayType: [],
      starRating: [],
      hotelName: '',
      sorting: 'Popularity',
      regionType: [],
      price: [price?.low, price?.high]
    }))
    setPricePerPerson([price?.low, price?.high]);
  };

  const SortingData = [
    {
      name: 'Popularity',
      value: 'Popularity',
    },
    {
      name: 'Price (low to high)',
      value: 'Price (low to high)',
    },
    {
      name: 'Price (high to low)',
      value: 'Price (high to low)',
    },
  ];

  const handleSorting = (e: any) => {
    setSessionStorage("click", "false")
    dispatch(setFilterState({ ...filters, sorting: e.target.value }));
  };

  //! Return
  return (
    <Dialog
      fullScreen
      sx={{
        // '& .MuiPaper-elevation ': {
        //   maxWidth: '600px',
        //   width: '100%',
        // },
        '& .MuiDialog-paper': {
          // margin: '15px !important',
          margin: '0 !important',
          padding: 0,
          width: '100%',
          maxWidth: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
      open={dialogState.filterDialog}
      // onClose={() => dispatch(setDialogState({ ...dialogState, filterDialog: false }))}
      className={'filter-modal'}
    >

      <>
        {/* HEADER */}
        <Box
          sx={{
            padding: "16px 20px",
            borderBottom: "1px solid #ddd",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexShrink: 0,
            bgcolor: colors.grey[50],
            maxHeight: "49px",
          }}
        >
          <Typography sx={{ fontWeight: 700, fontSize: "16px", lineHeight: "130%" }}>
            Filter & Sorting
          </Typography>

          <IconButton
            onClick={() => {
              setSessionStorage('click', 'false');
              dispatch(setDialogState({ ...dialogState, filterDialog: false }))
            }}
            disableRipple
          >
            <CloseIcon sx={{ color: colors.basics.black }} />
          </IconButton>
        </Box>

        {/* Content */}
        <Box p={{ md: "20px", sm: '20px', xs: '20px' }} sx={{
          overflowX: "hidden", flex: 1,              // <-- This forces content area to take all remaining space
          overflowY: "auto",    // <-- This makes only content scrollable
          padding: "20px",
        }}>

          <Box m="0 0 14px" border={`1px solid ${colors.grey[30]}`} borderRadius={"10px"} padding={"15px 20px"} bgcolor={colors.basics.white}>
            {/* <FormControl component="fieldset" variant="standard"> */}
            <Box display="flex" alignItems="center" mb="10px" flexDirection="row" justifyContent="space-between">
              <Box display="flex" alignItems="center" gap={1}>
                <Typography variant="subtitle1" fontWeight={700} fontFamily={"Raleway"} fontSize={"16px"}>
                  Sort
                </Typography>

                {/* Location Icon (same as screenshot) */}
                {/* <ImportExportOutlined /> */}
              </Box>

              {/* Arrow Icon (collapse/expand) */}
              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                {openSort ? (
                  <ExpandLessIcon sx={{ fontSize: 20, cursor: "pointer" }} onClick={() => setOpenSort(false)} />
                ) : (
                  <ExpandMoreIcon sx={{ fontSize: 20, cursor: "pointer" }} onClick={() => setOpenSort(true)} />
                )}
              </Box>
            </Box>
            {openSort && (<FormGroup
              sx={{
                display: 'flex',
                flexDirection: { md: 'col', xs: 'row' },
                '& label': {
                  flex: { lg: '0 0 100%', sm: '0 0 48%', xs: '0 0 100%' },
                  alignItems: 'flex-start',
                },
                ml: '10px',
                '& .MuiButtonBase-root': {
                  padding: '0',
                  mr: '15px',
                  mb: '5px',
                },
              }}
            >
              {SortingData?.map((data, index) => {
                return (
                  <FormControlLabel
                    key={index}
                    control={
                      <Radio
                        name="sorting"
                        value={data.value}
                        sx={{
                          pr: '12px',
                          '&.Mui-checked': {
                            color: isPlataniumHotel
                              ? colors.basics.plataniumGreenColor
                              : colors.basics.primary,
                          },
                          '& .MuiSvgIcon-root': {
                            borderRadius: "0px",
                          },
                        }}
                      />
                    }
                    label={data.name}
                    value={data.value}
                    checked={filters.sorting.includes(data.value)}
                    onChange={handleSorting}
                  />
                )
              })}
            </FormGroup>)}
            {/* {regionTypes.length > 5 &&
              (!showAll.region ? (
                <Box
                  sx={{
                    '& .MuiButton-endIcon>*:nth-of-type(1)': {
                      fontSize: '25px',
                    },
                    '& .MuiButton-endIcon': {
                      marginLeft: 0,
                    },
                    color: isPlataniumHotel ? colors.basics.plataniumGreenColor : colors.basics.primary,
                    '&:hover': isPlataniumHotel ? colors.basics.plataniumGreenColor : colors.basics.primary,
                  }}
                >
                  <Button
                    sx={{
                      justifyContent: 'left',
                      fontSize: '15px',
                      p: 0,
                      whiteSpace: 'nowrap',
                      color: isPlataniumHotel ? colors.basics.plataniumGreenColor : colors.basics.primary,
                      '&:hover': {
                        color: isPlataniumHotel
                          ? `${colors.basics.plataniumGreenColor} !important`
                          : `${colors.basics.primary}`
                      }
                    }}
                    onClick={() => {
                      handleChangeShowAllFilters('region');
                    }}
                    variant="text"
                    endIcon={<KeyboardArrowDownIcon />}
                  >
                    Show all
                  </Button>{' '}
                </Box>
              ) : (
                <Box
                  sx={{
                    '& .MuiButton-endIcon>*:nth-of-type(1)': {
                      fontSize: '25px',
                    },
                    '& .MuiButton-endIcon': {
                      marginLeft: 0,
                    },
                    color: isPlataniumHotel
                      ? colors.basics.plataniumGreenColor + '!important'
                      : colors.basics.primary,
                    '&:hover': {
                      color: isPlataniumHotel
                        ? `${colors.basics.plataniumGreenColor} !important`
                        : `${colors.basics.primary}`
                    }
                  }}
                >
                  <Button
                    onClick={() => {
                      handleChangeShowAllFilters('region');
                    }}
                    variant="text"
                    endIcon={<KeyboardArrowUpIcon />}
                    sx={{
                      justifyContent: 'left',
                      fontSize: '15px',
                      p: 0,
                      whiteSpace: 'nowrap',
                      color: isPlataniumHotel ? colors.basics.plataniumGreenColor : colors.basics.primary,
                    }}
                  >
                    Show less
                  </Button>
                </Box>
              ))} */}
            {/* </FormControl> */}
          </Box>
          <div hidden={regionTypes?.length <= 1}>
            <Box m="18px 0 14px" border={`1px solid ${colors.grey[30]}`} borderRadius={"10px"} padding={"15px 20px"} bgcolor={colors.basics.white}>
              {/* <FormControl component="fieldset" variant="standard"> */}
              <Box display="flex" alignItems="center" mb="10px" flexDirection="row" justifyContent="space-between">
                <Box display="flex" alignItems="center" gap={1}>
                  <Typography variant="subtitle1" fontWeight={700} fontFamily={"Raleway"} fontSize={"16px"}>
                    Region
                  </Typography>

                  {/* <RegionSearchIcon /> */}
                </Box>

                {/* Arrow Icon (collapse/expand) */}
                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                  {openRegion ? (
                    <ExpandLessIcon sx={{ fontSize: 20, cursor: "pointer" }} onClick={() => setOpenRegion(false)} />
                  ) : (
                    <ExpandMoreIcon sx={{ fontSize: 20, cursor: "pointer" }} onClick={() => setOpenRegion(true)} />
                  )}
                </Box>
              </Box>
              {openRegion && (<FormGroup
                sx={{
                  display: 'flex',
                  flexDirection: { md: 'col', xs: 'row' },
                  '& label': {
                    flex: { lg: '0 0 100%', sm: '0 0 48%', xs: '0 0 100%' },
                    alignItems: 'flex-start',
                  },
                  ml: '10px',
                  '& .MuiButtonBase-root': {
                    padding: '0',
                    mr: '15px',
                    mb: '5px',
                  },
                }}
              >
                {regionTypes?.slice(0, !showAll.region ? 5 : regionTypes.length)?.map((place, index) => {
                  return ((regionCounts[place])) > 0 &&
                    <FormControlLabel
                      key={index}
                      control={
                        <Checkbox
                          name={place}
                          sx={{
                            pr: '12px',
                            '&.Mui-checked': {
                              color: isPlataniumHotel
                                ? colors.basics.plataniumGreenColor
                                : colors.basics.primary,
                            },
                            '& .MuiSvgIcon-root': {
                              borderRadius: "0px",
                              // color: colors.grey[30],
                            },
                          }}
                        />
                      }
                      label={place + ' (' + (regionCounts[place] || 0) + ')'}
                      value={place}
                      checked={filters.regionType.includes(place)}
                      onChange={handleChangeRegionTypeFilter}
                    />
                })}
              </FormGroup>)}
              {openRegion && regionTypes.length > 5 &&
                (!showAll.region ? (
                  <Box
                    sx={{
                      '& .MuiButton-endIcon>*:nth-of-type(1)': {
                        fontSize: '25px',
                      },
                      '& .MuiButton-endIcon': {
                        marginLeft: 0,
                      },
                      color: isPlataniumHotel ? colors.basics.plataniumGreenColor : colors.basics.primary,
                      '&:hover': isPlataniumHotel ? colors.basics.plataniumGreenColor : colors.basics.primary,
                    }}
                  >
                    <Button
                      sx={{
                        justifyContent: 'left',
                        fontSize: '15px',
                        p: 0,
                        whiteSpace: 'nowrap',
                        color: isPlataniumHotel ? colors.basics.plataniumGreenColor : colors.basics.primary,
                        '&:hover': {
                          color: isPlataniumHotel
                            ? `${colors.basics.plataniumGreenColor} !important`
                            : `${colors.basics.primary}`
                        }
                      }}
                      onClick={() => {
                        handleChangeShowAllFilters('region');
                      }}
                      variant="text"
                      endIcon={<KeyboardArrowDownIcon />}
                    >
                      Show all
                    </Button>{' '}
                  </Box>
                ) : (
                  <Box
                    sx={{
                      '& .MuiButton-endIcon>*:nth-of-type(1)': {
                        fontSize: '25px',
                      },
                      '& .MuiButton-endIcon': {
                        marginLeft: 0,
                      },
                      color: isPlataniumHotel
                        ? colors.basics.plataniumGreenColor + '!important'
                        : colors.basics.primary,
                      '&:hover': {
                        color: isPlataniumHotel
                          ? `${colors.basics.plataniumGreenColor} !important`
                          : `${colors.basics.primary}`
                      }
                    }}
                  >
                    <Button
                      onClick={() => {
                        handleChangeShowAllFilters('region');
                      }}
                      variant="text"
                      endIcon={<KeyboardArrowUpIcon />}
                      sx={{
                        justifyContent: 'left',
                        fontSize: '15px',
                        p: 0,
                        whiteSpace: 'nowrap',
                        color: isPlataniumHotel ? colors.basics.plataniumGreenColor : colors.basics.primary,
                      }}
                    >
                      Show less
                    </Button>
                  </Box>
                ))}
              {/* </FormControl> */}
            </Box>
          </div>
          <Box m="18px 0 14px" border={`1px solid ${colors.grey[30]}`} borderRadius={"10px"} padding={"15px 20px"} bgcolor={colors.basics.white}>
            {/* <FormControl component="fieldset" variant="standard"> */}
            <Box display="flex" alignItems="center" mb="10px" flexDirection="row" justifyContent="space-between">
              <Box display="flex" alignItems="center" gap={1}>
                <Typography variant="subtitle1" fontWeight={700} fontFamily={"Raleway"} fontSize={"16px"}>
                  Holiday Types
                </Typography>

                {/* Location Icon (same as screenshot) */}
                {/* <HolidayTypeSearchIcon /> */}
              </Box>

              {/* Arrow Icon (collapse/expand) */}
              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                {openHoliday ? (
                  <ExpandLessIcon sx={{ fontSize: 20, cursor: "pointer" }} onClick={() => setOpenHoliday(false)} />
                ) : (
                  <ExpandMoreIcon sx={{ fontSize: 20, cursor: "pointer" }} onClick={() => setOpenHoliday(true)} />
                )}
              </Box>
            </Box>
            {openHoliday && (<FormGroup
              sx={{
                display: 'flex',
                ml: '10px',
                flexWrap: 'wrap',
                flexDirection: 'row',
                alignItems: 'center',
                '& label': {
                  flex: { sm: holidayTypes.length === 1 ? '0 0 100%' : '0 0 48%', xs: '0 0 100%' },
                  alignItems: 'center',

                },
              }}
            >
              {holidayTypes
                ?.slice(0, !showAll.hotels ? 5 : holidayTypes.length)
                ?.map((place: string, i: number) => {
                  return (filterCounts[place.split('~')[1]]) > 0 &&
                    <FormControlLabel
                      key={i}
                      control={
                        <Checkbox
                          name={place}
                          sx={{
                            pr: '12px',
                            '&.Mui-checked': {
                              color: isPlataniumHotel
                                ? colors.basics.plataniumGreenColor
                                : colors.basics.primary,
                            },
                            '& .MuiSvgIcon-root': {
                              borderRadius: "0px",
                              // color: colors.grey[30],
                            },
                          }}
                          disableRipple
                        />
                      }
                      label={place.split('~')[1] + ' (' + (filterCounts[place.split('~')[1]] || 0) + ')'}
                      value={place}
                      checked={filters.holidayType.includes(place)}
                      onChange={handleChangeHolidayTypeFilter}
                    />
                })}
            </FormGroup>)}

            {openHoliday && holidayTypes.length > 5 &&
              (!showAll.hotels ? (
                <Box
                  sx={{
                    '& .MuiButton-endIcon>*:nth-of-type(1)': {
                      fontSize: '25px',
                    },
                    '& .MuiButton-endIcon': {
                      marginLeft: 0,
                    },
                  }}
                >
                  {' '}
                  <Button
                    sx={{
                      justifyContent: 'left',
                      fontSize: '15px',
                      p: 0,
                      whiteSpace: 'nowrap',
                      color: isPlataniumHotel ? colors.basics.plataniumGreenColor : colors.basics.primary,
                      '&:hover': {
                        color: isPlataniumHotel
                          ? `${colors.basics.plataniumGreenColor} !important`
                          : `${colors.basics.primary}`
                      }
                    }}
                    onClick={() => {
                      handleChangeShowAllFilters('hotels');
                    }}
                    variant="text"
                    endIcon={<KeyboardArrowDownIcon />}
                  >
                    Show all
                  </Button>{' '}
                </Box>
              ) : (
                <Box
                  sx={{
                    '& .MuiButton-endIcon>*:nth-of-type(1)': {
                      fontSize: '25px',
                    },
                    '& .MuiButton-endIcon': {
                      marginLeft: 0,
                    },
                    color: isPlataniumHotel ? colors.basics.plataniumGreenColor : colors.basics.primary,
                  }}
                >
                  {' '}
                  <Button
                    onClick={() => {
                      handleChangeShowAllFilters('hotels');
                    }}
                    variant="text"
                    endIcon={<KeyboardArrowUpIcon />}
                    sx={{
                      justifyContent: 'left',
                      fontSize: '15px',
                      p: 0,
                      whiteSpace: 'nowrap',
                      color: isPlataniumHotel ? colors.basics.plataniumGreenColor : colors.basics.primary,
                      '&:hover': {
                        color: isPlataniumHotel
                          ? `${colors.basics.plataniumGreenColor} !important`
                          : `${colors.basics.primary}`
                      }
                    }}
                  >
                    Show less
                  </Button>
                </Box>
              ))}
            {/* </FormControl> */}
          </Box>
          {resultAvailableHotelRatings.length > 0 && (
            <>
              <Box m="18px 0 15px" border={`1px solid ${colors.grey[30]}`} borderRadius={"10px"} padding={"15px 20px"} bgcolor={colors.basics.white}>
                {/* <FormControl component="fieldset" variant="standard"> */}
                <Box display="flex" alignItems="center" mb="10px" flexDirection="row" justifyContent="space-between">
                  <Box display="flex" alignItems="center" gap={1}>
                    <Typography variant="subtitle1" fontWeight={700} fontFamily={"Raleway"} fontSize={"16px"}>
                      Star Rating
                    </Typography>

                    {/* Location Icon (same as screenshot) */}
                    {/* <RatingStarSearchIcon /> */}
                  </Box>

                  {/* Arrow Icon (collapse/expand) */}
                  <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    {openRating ? (
                      <ExpandLessIcon sx={{ fontSize: 20, cursor: "pointer" }} onClick={() => setOpenRating(false)} />
                    ) : (
                      <ExpandMoreIcon sx={{ fontSize: 20, cursor: "pointer" }} onClick={() => setOpenRating(true)} />
                    )}
                  </Box>
                </Box>
                {openRating && (<FormGroup
                  sx={{
                    ml: '10px',
                    '& .MuiButtonBase-root': {
                      p: 0,
                    },
                  }}
                >
                  {resultAvailableHotelRatings?.map((rating: number, i: number) => {
                    return rating > 0 && rating <= 5 ? (
                      <FormControlLabel
                        key={i}
                        control={
                          <Checkbox
                            sx={{
                              mr: "6px !important",
                            }}
                            disableRipple
                          />
                        }
                        value={rating}
                        label={
                          <Box sx={{
                            textAlign: { xs: "left", sm: "center" },
                            // mt: { lg: 0, xs: "15px" },
                            "& .MuiRating-root .MuiRating-iconFilled": {
                              color: colors.basics.primary,
                            },
                            "& .MuiRating-iconHover": {
                              color: colors.basics.primary,
                            },
                          }}>
                            <Rating
                              sx={{ fontSize: '16px' }}
                              emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />}
                              defaultValue={rating}
                              precision={rating % 1 === 0 ? 1 : 0.5}
                              readOnly={true}
                            /></Box>
                        }
                        checked={filters.starRating.includes(Number(rating))}
                        onChange={(e) => {
                          // resultAvailableHotelRatings?.includes(String(rating)) &&
                          handleChangeRating(e);
                        }}
                      // sx={{ gap: '5px', alignItems: 'center', }}
                      />
                    ) : null;
                  })}
                </FormGroup>)}
                {/* </FormControl> */}
              </Box>
              {/* <Divider /> */}
            </>
          )}
          {holidayPackage?.Packages?.results?.length > 1 &&
            <Box m="18  px 0 14px" border={`1px solid ${colors.grey[30]}`} borderRadius={"10px"} padding={"15px 20px"} bgcolor={colors.basics.white}>

              <Box display="flex" alignItems="center" mb="10px" flexDirection="row" justifyContent="space-between">
                <Box display="flex" alignItems="center" gap={1}>
                  <Typography variant="subtitle1" fontWeight={700} fontFamily={"Raleway"} fontSize={"16px"}>
                    Price (per person)
                  </Typography>

                  {/* Location Icon (same as screenshot) */}
                  {/* <MaxPriceSearchIcon /> */}
                </Box>

                {/* Arrow Icon (collapse/expand) */}
                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                  {openPrice ? (
                    <ExpandLessIcon sx={{ fontSize: 20, cursor: "pointer" }} onClick={() => setOpenPrice(false)} />
                  ) : (
                    <ExpandMoreIcon sx={{ fontSize: 20, cursor: "pointer" }} onClick={() => setOpenPrice(true)} />
                  )}
                </Box>
              </Box>
              {openPrice && (<>
                <Typography variant="body1" fontWeight={500} mb="9px">
                  {signForPricing + pricePerPerson[0]} - {signForPricing + pricePerPerson[1]}
                </Typography>
                <Box
                  pl={0.5}
                  pr={1.5}
                  sx={{
                    '& .MuiSlider-thumb': {
                      color: colors.basics.black,  //colors.grey[10],
                      width: 15,
                      height: 15,
                      backgroundColor: "white",     // dark outer circle
                      border: "4px solid",   // inner white center
                      boxShadow: "none",
                      "&:hover, &.Mui-focusVisible, &.Mui-active": {
                        boxShadow: "none",
                      },
                    },
                    '& .MuiSlider-rail': {
                      color: colors.grey[50],
                    },
                    '& .MuiSlider-track': {
                      color: colors.basics.black,// colors.grey[10],                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                
                    },
                  }}
                >
                  <Slider
                    onChangeCommitted={(event: React.SyntheticEvent | Event, val: any) => {
                      dispatch(setFilterState({ ...filters, price: val }));
                      dispatch(setFindButtonClick(false));
                    }}
                    min={price?.low || 0}
                    max={price?.high || 10500}
                    valueLabelDisplay="auto"
                    value={pricePerPerson || 0}
                    aria-labelledby="range-slider"
                    onChange={(e, val: number | any) => {
                      setPricePerPerson(val);
                    }}
                  />
                </Box>
              </>)}
            </Box>}
        </Box>

        {/* Footer */}
        <Box
          sx={{
            padding: "16px 20px",
            borderTop: "1px solid #ddd",
            flexShrink: 0,
            maxHeight: "80px",
          }}
          display="flex"
          justifyContent="space-between"
        >
          <Box>
            <Button
              variant="text"
              fullWidth
              onClick={handleReset}
              sx={{
                color: colors.grey[10] + "!important",
                fontWeight: 700,
                fontSize: "16px",
                fontFamily: "Raleway",
                textDecoration: "underline!important",
                textUnderlineOffset: "3px",
                padding: "10px",
              }}
            >
              Reset filters
            </Button>
          </Box>
          <Box>
            <Button
              variant="contained"
              fullWidth
              onClick={() => {
                setSessionStorage('click', 'false');
                dispatch(setDialogState({ ...dialogState, filterDialog: false }));
              }}
              sx={{
                background: isPlataniumHotel
                  ? colors.basics.plataniumGreenColor
                  : colors.basics.primary,
                "&:hover": {
                  background: isPlataniumHotel
                    ? colors.basics.plataniumGreenColor
                    : colors.basics.primary,
                },
                fontWeight: 700,
                fontSize: "16px",
                fontFamily: "Raleway",
                padding: "10px",
              }}
            >
              Show {filteredHolidayPackage?.Packages?.results.length} holidays
            </Button>
          </Box>
        </Box>

      </>

    </Dialog >
  );
};

export default FilterSearchDialog;
